import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { RemoveCryoboxFromStagingFormValues } from './types';
import { RemoveCryoboxFromStagingResult } from '../../core/api/lab.types';

export const removeCryoboxFromStagingHasErrorSelector = (state: RootState): any =>
  state.removeCryoboxFromStaging.errors && state.removeCryoboxFromStaging.errors
    ? { hasError: true, message: state.removeCryoboxFromStaging.errors[0].message }
    : { hasError: false };

export const removeCryoboxFromStagingIsBusySelector = (state: RootState): boolean =>
  state.removeCryoboxFromStaging.status === StoreStatus.BUSY;

export const removeCryoboxFromStagingValuesSelector = (state: RootState): RemoveCryoboxFromStagingFormValues | null =>
  state.removeCryoboxFromStaging.values || null;

export const removeCryoboxFromStagingResponseSelector = (state: RootState): RemoveCryoboxFromStagingResult | null =>
  state.removeCryoboxFromStaging.response || null;
